import React from "react";

export interface AiBriefTileProps {
  /** Main text; can be string or React node (e.g. with <b> for emphasis). */
  text: React.ReactNode;
}

export function AiBriefTile({ text }: AiBriefTileProps) {
  return (
    <div className="ai-brief">
      <div className="ai-brief-icon" aria-hidden>✦</div>
      <div className="ai-brief-text">{text}</div>
      <div className="ai-brief-tag">✦ AI Plan</div>
    </div>
  );
}
